import { useMutation, useQueryClient } from '@tanstack/react-query'
import ConfirmationModal from 'components/ConfirmationModal'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

type DeleteProps = {
  opened: boolean
  closeModal: () => void
  itemsBudget: ItemsBudgetApiResponse
}

export default function Delete({
  opened,
  closeModal,
  itemsBudget,
}: DeleteProps) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { openErrorToast, openSuccessToast } = useGlobalState()

  const removeItemsBudget = useMutation({
    mutationFn: async (itemsBudget: ItemsBudget) => {
      await ApiService.ItemsBudget.remove(itemsBudget.id.toString())
    },
    onSuccess: (_data, itemsBudget: ItemsBudget) => {
      queryClient.setQueryData<ItemsBudget[]>(
        QUERY_KEYS.ITEMS_BUDGET.LIST,
        (oldItemsBudget) => {
          if (!oldItemsBudget?.length) return

          return oldItemsBudget.filter(
            (oldItemsBudget) => oldItemsBudget.id !== itemsBudget.id,
          )
        },
      )

      queryClient.removeQueries(
        QUERY_KEYS.ITEMS_BUDGET.EDIT(itemsBudget.id.toString()),
      )

      openSuccessToast({
        message: `O item de orçamento ${itemsBudget.name} foi removido com sucesso!`,
      })

      navigate(ROUTES.ITEMS_BUDGET.LIST)
    },
    onError: (removeError) => {
      closeModal()

      openErrorToast({
        message: (removeError as ApiError).message,
      })
    },
  })

  if (!opened) {
    return <></>
  }

  return (
    <ConfirmationModal
      opened
      title="Confirmar remoção"
      onClose={closeModal}
      onCancel={closeModal}
      onConfim={() => removeItemsBudget.mutate(itemsBudget)}
      confirmColor="error"
    >
      Deseja realmente remover o item de orçamento{' '}
      <strong>{`${itemsBudget?.name}?`}</strong>
    </ConfirmationModal>
  )
}
